// Central Azure/Entra icon registry.
// Official Microsoft SVGs live in /public/azure-icons/v24 (see NOTICE.txt).
// UI_REFERENCE_DATE: 2026-08 — Azure changes continuously; re-verify on refresh.
const BASE = "/azure-icons/v24";

// Icon key -> file
const ICONS = {
  "virtual-machine": "virtual-machine.svg",
  "vm-scale-set": "vm-scale-set.svg",
  disk: "disk.svg",
  snapshot: "snapshot.svg",
  image: "image.svg",
  "function-app": "function-app.svg",
  "virtual-network": "virtual-network.svg",
  subnet: "subnet.svg",
  nsg: "nsg.svg",
  nic: "nic.svg",
  "public-ip": "public-ip.svg",
  "load-balancer": "load-balancer.svg",
  "app-gateway": "app-gateway.svg",
  firewall: "firewall.svg",
  "vnet-gateway": "vnet-gateway.svg",
  "dns-zone": "dns-zone.svg",
  "route-table": "route-table.svg",
  "private-endpoint": "private-endpoint.svg",
  "storage-account": "storage-account.svg",
  blob: "blob.svg",
  queue: "queue.svg",
  table: "table.svg",
  "file-share": "file-share.svg",
  "app-service": "app-service.svg",
  "app-service-plan": "app-service-plan.svg",
  "azure-sql": "azure-sql.svg",
  "sql-database": "sql-database.svg",
  "sql-server": "sql-server.svg",
  "sql-managed-instance": "sql-managed-instance.svg",
  "key-vault": "key-vault.svg",
  defender: "defender.svg",
  monitor: "monitor.svg",
  "log-analytics": "log-analytics.svg",
  "app-insights": "app-insights.svg",
  "activity-log": "activity-log.svg",
  policy: "policy.svg",
  "cost-management": "cost-management.svg",
  "all-resources": "all-resources.svg",
  "resource-group": "resource-group.svg",
  subscription: "subscription.svg",
  "management-group": "management-group.svg",
  dashboard: "dashboard.svg",
  recent: "recent.svg",
  marketplace: "marketplace.svg",
  tag: "tag.svg",
  help: "help.svg",
  location: "location.svg",
  "container-registry": "container-registry.svg",
  "managed-identity": "managed-identity.svg",
  "cloud-shell": "cloud-shell.svg",
  users: "users.svg",
  groups: "groups.svg",
  roles: "roles.svg",
  "enterprise-apps": "enterprise-apps.svg",
  "app-registrations": "app-registrations.svg",
  "id-protection": "id-protection.svg",
  pim: "pim.svg",
  licenses: "licenses.svg",
  mfa: "mfa.svg",
  "conditional-access": "conditional-access.svg",
  "id-governance": "id-governance.svg",
  "entra-id": "entra-id.svg",
  entra: "entra.svg",
  "verified-id": "verified-id.svg",
  "global-secure-access": "global-secure-access.svg",
  generic: "generic.svg",
};

// ARM resource type -> icon key
const TYPE_MAP = {
  "microsoft.compute/virtualmachines": "virtual-machine",
  "microsoft.compute/virtualmachinescalesets": "vm-scale-set",
  "microsoft.compute/disks": "disk",
  "microsoft.compute/snapshots": "snapshot",
  "microsoft.compute/images": "image",
  "microsoft.web/sites": "app-service",
  "microsoft.web/sites/functions": "function-app",
  "microsoft.web/serverfarms": "app-service-plan",
  "microsoft.network/virtualnetworks": "virtual-network",
  "microsoft.network/networksecuritygroups": "nsg",
  "microsoft.network/networkinterfaces": "nic",
  "microsoft.network/publicipaddresses": "public-ip",
  "microsoft.network/loadbalancers": "load-balancer",
  "microsoft.network/applicationgateways": "app-gateway",
  "microsoft.network/azurefirewalls": "firewall",
  "microsoft.network/virtualnetworkgateways": "vnet-gateway",
  "microsoft.network/dnszones": "dns-zone",
  "microsoft.network/routetables": "route-table",
  "microsoft.network/privateendpoints": "private-endpoint",
  "microsoft.storage/storageaccounts": "storage-account",
  "microsoft.sql/servers": "sql-server",
  "microsoft.sql/servers/databases": "sql-database",
  "microsoft.sql/managedinstances": "sql-managed-instance",
  "microsoft.keyvault/vaults": "key-vault",
  "microsoft.insights/components": "app-insights",
  "microsoft.operationalinsights/workspaces": "log-analytics",
  "microsoft.containerregistry/registries": "container-registry",
  "microsoft.managedidentity/userassignedidentities": "managed-identity",
  "microsoft.resources/resourcegroups": "resource-group",
  "microsoft.resources/subscriptions": "subscription",
};

export function iconKeyForType(type) {
  if (!type) return "generic";
  return TYPE_MAP[type.toLowerCase()] || "generic";
}

export function iconSrc(key) {
  return `${BASE}/${ICONS[key] || ICONS.generic}`;
}

export function iconSrcForType(type) {
  return iconSrc(iconKeyForType(type));
}

export { ICONS };
